<template>
  <v-row dense class="d-flex " title='' style="height: 48px">
    <!-- View Title -->
    <v-col md="auto">
      <ViewTitle :title=context_title />
    </v-col>
    <!-- /View Title -->
    <!-- Add Button-->
    <v-col  >
      <ExplorerHeaderAddButton />
    </v-col>
    <v-spacer>
    </v-spacer>

   <v-col cols="2"
      class="text-right mb-0 pb-0"
      v-if="current_view==='ExplorerCalendar'"
    >
      <ExplorerCalendarHeader
        :calendar_props="calendar_props"
        v-on:calendar-action="calendarAction"
      />
    </v-col>    
    <v-col
      class="d-flex justify-end mb-0 pb-0"
      md="auto"      
    >
      <v-menu
        close-on-content-click
        dense
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- TODO: Create SelectMenu component -->
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="qmkey-btn-process-filter"
          :class="active ? 'qmkey-btn-process-filter-active' : ''"
        >
          <v-row
            no-gutters
            align="center"
            justify="start"
            class="mr-0 pr-0"
            style="height: 36px"
          >
            <v-col
              cols="auto"
              class="mr-4 text-left"
              tile
              outlined
              style="min-width: 180px"
            >
              {{ current_process_name }}
            </v-col>
            <v-col
              cols="auto"
              tile
              class="mr-0 border-right"
              style="height: 36px"
            >
              <!--
                   Trick: If you specify a height on a column, then it won't
                   vertically align. So we create an empty one with right border
              -->
            </v-col>
            <v-col
              cols="auto"
              class="ma-0"
              tile
              outlined
            >
              <v-icon right class="icon-large">mdi-chevron-down</v-icon>
            </v-col>
          </v-row>
        </v-btn>
      </template>
      <!-- TODO: order process by parent -->
      <v-list
        dense
        small
        flat
        class="overflow-y-auto qmkey-proceso-menu-contents">
        <v-list-item
          small
          v-for="proc in filteredProcesses"
          :key="proc.id"
          @click.prevent="setProcess(proc.id)"
          :input-value="processID === proc.id"
          active-class="qmkey-proceso-menu-item-active"
          :disabled="processID === proc.id"
          class="qmkey-proceso-menu-item"
        >
          <ProcessMenuItem :process="proc" />
        </v-list-item>
      </v-list>
      </v-menu>
    </v-col>
    <v-divider
      class="mt-1 pb-0 mx-2 explorer-header-component"
      vertical
      inset
    ></v-divider>    
    <v-col
      class="d-flex justify-end mb-0 pb-0"
      md="auto"
    >
      <ExplorerHeaderDatesRangeFilter  @input="setFilterDates"/>
    </v-col>
    <v-col
      class="d-flex justify-end mb-0 pb-0"
      md="auto"
    >
      <ExplorerHeaderAdvancedFilter @input="setFilterForm"/>
    </v-col>
    <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
    >
      <SearchTextTable @input="setSearchText"/>
    </v-col>    
    <v-divider
      class="mt-1 pb-0 mx-2 explorer-header-component"
      vertical
      inset
    ></v-divider>
    <v-col class="text-right mb-1 pb-0" md="auto">
      <v-btn-toggle 
        active-class="qmkey-explorer-view-active"
        background-color="white"
        borderless
        dense
        tile
        v-model="selected_view"
        mandatory
      >
        <v-btn           
          @click="goToExplorer('ExplorerTable', 1)"
          value="ExplorerTable"
          active-class="qmkey-explorer-view-active"
          icon
        >
            <v-icon>mdi-format-list-checkbox</v-icon>
        </v-btn>
        <v-btn           
          @click="goToExplorer('ExplorerCalendar', 2)"
          value="ExplorerCalendar"
          icon
        >
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
        <v-btn 
          @click="goToExplorer('ExplorerReport', 3)"
          value="ExplorerReport"
          icon
        >
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <v-divider
      class="mt-1 pb-0 mx-1 explorer-header-component"
      vertical
      inset
    ></v-divider>  
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import ExplorerHeaderAddButton from './ExplorerHeaderAddButton'
import ExplorerHeaderAdvancedFilter from './ExplorerHeaderAdvancedFilter'
import ExplorerHeaderDatesRangeFilter from './ExplorerHeaderDatesRangeFilter'
import ExplorerCalendarHeader from './ExplorerCalendarHeader'
import SearchTextTable from '@/components/SearchTextTable'
import ProcessMenuItem from './ProcessMenuItem'


export default {
  name: 'ExplorerHeader',
  components: { 
    ViewTitle, 
    ExplorerHeaderAddButton,
    ExplorerHeaderAdvancedFilter,
    SearchTextTable,
    ExplorerHeaderDatesRangeFilter,
    ProcessMenuItem,
    ExplorerCalendarHeader,
  },

  props: ['calendar_props'],

  data() {
    return {
      error_message: '',
      menu_context: '',
      filter_fields_to_collect: [],
      filter_form_error_message: '',
      jsData: '',
      parentData: 'init data',
      selected_view: 'ExplorerTable',
      current_process_name: 'Escoger Proceso',
      active: false,
    }
  },

  computed: {
    ...mapGetters(['isUser', 'isManager', 'isAdmin']),
    ...mapState([
      'menus',
      'sitePath',
      'allSites',
      'processID',
      'allStandards',
      'filteredProcesses',
      'allProcesses',
      'currentStandardID',
      'processID',
      'current_unit',
      'current_business_process',
      'searchText',
      'filtersFormData',
      'current_business_process_name',
      'context_title',
      'current_view',
    ]),
  },
  mounted: function() {
    // this.REFRESH_STATE(this)
    this.SET_CURRENT_VIEW('ExplorerTable')
    this.explorer_button = 'ExplorerTable'
  },
  updated: function() {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }
  },
  methods: {
    handleFcAfterDateBack (event) {
      // get the data after child dealing
      this.parentData = event
    },
    setSearchText(search_text) {
      this.SET_SEARCH_TEXT(search_text)
      if (this.current_view === 'ExplorerTable'){
          this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: search_text,
            filters_form: this.filtersFormData,
            units_page: 1,
          })
        }
        else if (this.current_view === 'ExplorerCalendar'){
          this.EXPLORE_UNITS_CALENDAR({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: search_text,
            filters_form: this.filtersFormData,
            start: this.calendar_props.start.date,
            end: this.calendar_props.end.date,
          })
        }
    },
    setFilterDates(dates_range){
      this.SET_FILTER_DATES(dates_range)
      if (this.current_view === 'ExplorerTable'){
        this.EXPLORE_UNITS({
          site: this.sitePath,
          bp_reference: this.current_business_process,
          process_id: this.processID,
          search_text: this.searchText,
          filters_form: this.filtersFormData,
          units_page: 1,
          filter_dates: dates_range,
        })
      }
      else if (this.current_view === 'ExplorerCalendar'){
        this.calendar_props.start = new Date(dates_range[0])
        this.calendarAction('setFocus', dates_range[0])
      //   // this.EXPLORE_UNITS_CALENDAR({
      //   //   site: this.sitePath,
      //   //   bp_reference: this.current_business_process,
      //   //   process_id: this.processID,
      //   //   search_text: this.searchText,
      //   //   start: dates_range[0],
      //   //   end: dates_range[1],
      //   // })
      }
    },
    ...mapActions(['GET_SITES', 'REFRESH_STATE', 'EXPLORE_UNITS', 'EXPLORE_UNITS_CALENDAR']),
    ...mapMutations([
      'SET_USER',
      'SET_CURRENT_SITE',
      'SET_CURRENT_STANDARD',
      'SET_CURRENT_PROCESS',
      'SET_BUSINESS_PROCESS',
      'SET_SEARCH_TEXT',
      'SET_FILTER_FORM',
      'SET_CURRENT_VIEW',
      'SET_CONTEXT_TITLE',
      'SET_FILTER_DATES',
    ]),
    goToExplorer(view_name, button){
      this.SET_CURRENT_VIEW(view_name)
      this.selected_view = view_name
    },
    setProcess(id) {
      this.SET_CURRENT_PROCESS(id)
      let name = 'Escoger Proceso'
      let filtered = false
      if (!this.processID == '') {
        for (var i=0; i< this.filteredProcesses.length;i++){
            if (this.filteredProcesses[i].id === this.processID ){ 
                name = this.filteredProcesses[i].name
                filtered = true
            }
        }
      }
      this.active = filtered
      this.current_process_name = name
      if (this.current_business_process){
        if (this.current_view === 'ExplorerTable'){
          this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: id,
            search_text: this.searchText,
            filters_form: this.filtersFormData,
            units_page: 1,
          })
        }
        else if (this.current_view === 'ExplorerCalendar'){
          this.EXPLORE_UNITS_CALENDAR({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: id,
            search_text: this.searchText,
            filters_form: this.filtersFormData,
            start: this.calendar_props.start.date,
            end: this.calendar_props.end.date,
          })
        }
      }
    },
    calendarAction(action, ...args) {
      this.$emit('calendar-action', action, ...args);
    },
    setFilterForm(bodyFormData){
      this.SET_FILTER_FORM(bodyFormData)
      if (this.current_view=='ExplorerTable'){
        this.EXPLORE_UNITS({
          site: this.sitePath,
          bp_reference: this.current_business_process,
          process_id: this.processID,
          search_text: this.searchText,
          filters_form: bodyFormData,
          units_page: 1,
        })
      }
      else if (this.current_view === 'ExplorerCalendar'){
        this.EXPLORE_UNITS_CALENDAR({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: this.searchText,
            filters_form: bodyFormData,
            start: this.calendar_props.start.date,
            end: this.calendar_props.end.date,
        })
      }
    }
  },
}
</script>


<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
